"use strict";

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.object.keys.js");

require("core-js/modules/es6.array.reduce.js");

module.exports = function (obj, defaults) {
  return Object.keys(defaults).concat(Object.keys(obj)).reduce(function (target, prop) {
    target[prop] = typeof obj[prop] === 'undefined' ? defaults[prop] : obj[prop];
    return target;
  }, {});
};